import React, {useState} from "react";
import { ChromePicker } from 'react-color';
import CheckIcon from "../../../icons/CheckIcon";
import TrashIcon from "../../../icons/TrashIcon";

function InputColor (props) {
    const {
        attribute,
        returnType,
        classname,
        value,
        handleChange,
        handleBlur
    } = props;
    const [ box, setBox ] = useState(false);

    const showBoxColor = () => {
        setBox(true);
    }
    const handleClose = () => {
        setBox(false);
    }
    const handleRemove = () => {
        handleChange(attribute, returnType, "");
    }
    const changeEvent = (color, event) => {
        if (handleChange === undefined || handleChange === null) return;
        handleChange(attribute, returnType, color.hex);
    }
    const blurEvent = () => {
        if (handleBlur === undefined || handleBlur === null) return;
        handleBlur();
    }

    return (
        <div className={ "inputColor " + (classname !== undefined ? classname : "") }>
            <div className="color extend">
                <p onClick={ showBoxColor }>{ value }</p>
                <span
                    className="puce"
                    style={value !== "" ? {backgroundColor: value} : {}}
                    onClick={ showBoxColor } />
                <TrashIcon classname="trash" handleClick={ handleRemove } />
            </div>
            {
                box
                && <div className="popover">
                    <div className="cover" onClick={ handleClose }/>
                    <ChromePicker
                        color={ value }
                        onChange={ changeEvent }
                        disableAlpha={ true }
                    />
                </div>
            }
            <div className="clearing" />
        </div>
    );
}

export default InputColor;
